import photo from '../../assets/images/photos_stub.png';
import {
	StyledContainer,
	StyledDeleteButton,
	StyledPhoto,
	StyledPhotoContainer,
	StyledPhotoWrapper,
	StyledTitle,
} from './AppPhotosPhoto.styled';

const AppPhotosPhoto = ({
	setIsPhoto,
}: {
	setIsPhoto: (isPhoto: boolean) => void;
}) => {
	return (
		<StyledContainer>
			<StyledTitle>24.05.26</StyledTitle>
			<StyledPhotoContainer>
				<StyledPhotoWrapper onClick={() => setIsPhoto(false)}>
					<StyledPhoto src={photo} />
				</StyledPhotoWrapper>
			</StyledPhotoContainer>
			<StyledDeleteButton />
		</StyledContainer>
	);
};

export { AppPhotosPhoto };
